import { ReactNode, useMemo } from "react"
import { GenericListContext } from "../hooks/context"
import { useGenericListState } from "../hooks/useGenericListState"
import { GenericListServiceConfig } from "../types"

export interface DataProviderProps extends GenericListServiceConfig {
  children: ReactNode
  mainId?: string
  format?: (data: any) => any
}

export const DataProvider = ({
  children,
  getListLocation,
  TITLE,
  LOADING_MESSAGE,
  IMAGES_BUCKET,
  columnsProperties,
  uiSchema,
  imageProcessor,
  EDIT_TITLE,
  ADD_TITLE,
  onRowClick,
  schema,
  fields,
  widgets,
  ObjectFieldTemplate,
  options,
  prepareFormData,
  prepareListData,
  otherProps,
  mainId,
  format,
}: DataProviderProps) => {
  const Service = useMemo(
    () => ({
      getListLocation,
      TITLE,
      LOADING_MESSAGE,
      IMAGES_BUCKET,
      EDIT_TITLE,
      ADD_TITLE,
      columnsProperties,
      uiSchema,
      imageProcessor,
      onRowClick,
      schema,
      fields,
      widgets,
      ObjectFieldTemplate,
      options,
      prepareFormData,
      prepareListData,
      otherProps,
    }),
    [
      getListLocation,
      TITLE,
      LOADING_MESSAGE,
      IMAGES_BUCKET,
      EDIT_TITLE,
      ADD_TITLE,
      columnsProperties,
      uiSchema,
      imageProcessor,
      onRowClick,
      schema,
      fields,
      widgets,
      ObjectFieldTemplate,
      options,
      prepareFormData,
      prepareListData,
      otherProps,
    ],
  )

  const { list, loading, columns, options: tableOptions, reload, openAdd, openEdit } = useGenericListState(
    Service,
    mainId,
    format,
  )

  const contextValue = useMemo(
    () => ({
      list,
      loading,
      columns,
      options: tableOptions,
      reload,
      openAdd,
      openEdit,
      mainId,
      Service,
      format,
    }),
    [list, loading, columns, tableOptions, reload, openAdd, openEdit, mainId, Service, format],
  )

  return <GenericListContext.Provider value={contextValue}>{children}</GenericListContext.Provider>
}
